/* @jsx mdx */
import React from 'react'
import { mdx } from '@mdx-js/react'

import { Cite, Slide, Heading, Text, Box, FlexBox, Image, Appear, Markdown } from "spectacle";
import {LeftContentRightContent, LeftCodeRightContent, LeftCodeRightMarkdown, LeftContentRightMarkdown, LeftCodeRightCode} from "components/layout";

function MDXContentWrapperSlide0(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */



const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const TitleDummy = makeShortcode("TitleDummy");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    {
      /* prettier-ignore-start */
    }
    {
      /* prettier-ignore-end */
    }
    <TitleDummy mdxType="TitleDummy" />
    <h1>{`The State of Redux`}</h1>
    <h3>{`Mark Erikson`}</h3>
    <h3><a parentName="h3" {...{
        "href": "https://twitter.com/acemarke"
      }}>{`@acemarke`}</a></h3>
    <h4>{`May 2021`}</h4>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide0.isMDXComponent = true;

function MDXContentWrapperNotes0(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */




const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes0.isMDXComponent = true;


export const notes = [MDXContentWrapperNotes0];


export default [MDXContentWrapperSlide0]